export const Roles = {
    PHYSICIAN: 'ROLE_PHYSICIAN',
    PATIENT: 'ROLE_PATIENT',
    MIRUS_ADMIN: 'ROLE_MIRUS_ADMIN',
    ADMIN: 'ROLE_ORG_ADMIN',
    STAFF: 'ROLE_STAFF',
    BILLING: 'ROLE_BILLING',
    MIRUS_NURSE: 'ROLE_MIRUS_NURSE',
}

export const RolesMap = {
    ROLE_PHYSICIAN: 'Physician',
    ROLE_PATIENT: 'Patient',
    ROLE_MIRUS_ADMIN: 'Mirus Admin',
    ROLE_ORG_ADMIN: 'Admin',
    ROLE_STAFF: 'Staff',
    ROLE_BILLING: 'Billing',
    ROLE_MIRUS_NURSE: 'Mirus Nurse'
}

export const getRoleDisplayName = (roles) => {
    return roles?.map(role => {
        return { key: role, value: RolesMap[role] }
    });
}
